// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as SidebarPadSyncHook$GameDataCore from "./SidebarPadSyncHook.res.mjs";

var appShellNarrowMaxPx = 1479;

var snapThreshold = 136;

var expandedStorageKey = "gdc.mainNavRailExpanded";

var widthStorageKey = "gdc.mainNavRailWidth";

var railWidthVar = "--gdc-main-nav-rail-width";

var emptyPayload = ({});

function isDrawerViewport(viewportWidth) {
  return viewportWidth <= appShellNarrowMaxPx;
}

function snapNavRailWidth(w) {
  if (w >= snapThreshold) {
    return 220;
  } else {
    return 52;
  }
}

function clampNavRailPreviewWidth(w) {
  return Math.max(52, Math.min(220, w));
}

function getSavedExpanded() {
  var match = sessionStorage.getItem(expandedStorageKey);
  if (!(match == null) && match === "1") {
    return true;
  }
  var raw = sessionStorage.getItem(widthStorageKey);
  if (raw == null) {
    return false;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && !Number.isNaN(n)) {
    return n >= snapThreshold;
  } else {
    return false;
  }
}

function setSavedExpanded(expanded) {
  sessionStorage.setItem(expandedStorageKey, expanded ? "1" : "0");
  sessionStorage.setItem(widthStorageKey, String(expanded ? 220 : 52));
}

function getSavedWidth() {
  if (getSavedExpanded()) {
    return 220;
  } else {
    return 52;
  }
}

function readRailWidthVar() {
  var raw = getComputedStyle(document.documentElement).getPropertyValue(railWidthVar).trim();
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n > 0) {
    return n;
  } else {
    return getSavedWidth();
  }
}

function getMainNavRailWidth() {
  return readRailWidthVar();
}

function setRailDataset(rail, w) {
  if (rail !== undefined) {
    Caml_option.valFromOption(rail).setAttribute("data-expanded", w > 52 ? "true" : "false");
    return ;
  }
  
}

function applyNavRailWidthPx(w) {
  var px = String(w) + "px";
  var rootStyle = document.documentElement.style;
  rootStyle.setProperty(railWidthVar, px);
  rootStyle.setProperty("--spacing-side-bar-width", px);
  rootStyle.setProperty("--spacing-side-bar-width-sm", px);
  setRailDataset(Caml_option.nullable_to_opt(document.getElementById("main-nav-rail")), w);
}

function previewRailWidth(w) {
  applyNavRailWidthPx(clampNavRailPreviewWidth(w));
  SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
}

function commitRailWidth(w) {
  var snapped = snapNavRailWidth(w);
  applyNavRailWidthPx(snapped);
  setSavedExpanded(snapped === 220);
  SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
  dispatchEvent(new CustomEvent("gdc:main-nav-rail-resize", emptyPayload));
}

function applyPersistedMainNavRail() {
  commitRailWidth(getSavedWidth());
}

function isResizing(rail) {
  var value = rail._gdcIsResizing;
  if (value !== undefined) {
    return value;
  } else {
    return false;
  }
}

function finishResizeInteraction(rail) {
  rail._gdcIsResizing = false;
  DomEl$GameDataCore.removeClass(document.body, "gdc-nav-rail-resizing");
  var body = document.body.style;
  body.cursor = "";
  body.userSelect = "";
}

function removeHandleListener(handle, type_, handler) {
  if (handler !== undefined) {
    handle.removeEventListener(type_, handler);
    return ;
  }
  
}

function unbindResizeHandle(rail) {
  var handle = rail._gdcBoundHandle;
  if (handle !== undefined) {
    var handle$1 = Caml_option.valFromOption(handle);
    removeHandleListener(handle$1, "pointerdown", rail._gdcPointerDown);
    removeHandleListener(handle$1, "pointermove", rail._gdcPointerMove);
    removeHandleListener(handle$1, "pointerup", rail._gdcPointerUp);
    removeHandleListener(handle$1, "pointercancel", rail._gdcPointerCancel);
  }
  rail._gdcBoundHandle = undefined;
  rail._gdcPointerDown = undefined;
  rail._gdcPointerMove = undefined;
  rail._gdcPointerUp = undefined;
  rail._gdcPointerCancel = undefined;
}

function bindResizeHandle(rail) {
  var handle = rail.querySelector("[data-main-nav-resize-handle]");
  if (handle == null) {
    return ;
  }
  var existing = rail._gdcBoundHandle;
  if (existing !== undefined && Caml_option.valFromOption(existing) === handle) {
    return ;
  }
  unbindResizeHandle(rail);
  var onPointerDown = function ($$event) {
    var tmp = true;
    if ($$event.button === 0) {
      var viewportWidth = window.innerWidth;
      tmp = viewportWidth <= appShellNarrowMaxPx;
    }
    if (tmp) {
      return ;
    }
    handle.setPointerCapture($$event.pointerId);
    rail._gdcIsResizing = true;
    rail._gdcDragStartX = $$event.clientX;
    rail._gdcDragStartWidth = readRailWidthVar();
    rail._gdcDidDrag = false;
    DomEl$GameDataCore.addClass(document.body, "gdc-nav-rail-resizing");
    var body = document.body.style;
    body.cursor = "ew-resize";
    body.userSelect = "none";
    $$event.preventDefault();
  };
  var onPointerMove = function ($$event) {
    if (!isResizing(rail)) {
      return ;
    }
    var match = rail._gdcDragStartX;
    var match$1 = rail._gdcDragStartWidth;
    if (match === undefined) {
      return ;
    }
    if (match$1 === undefined) {
      return ;
    }
    var delta = $$event.clientX - match;
    if (Math.abs(delta) > 4) {
      rail._gdcDidDrag = true;
    }
    previewRailWidth(match$1 + (delta | 0) | 0);
  };
  var onPointerUp = function ($$event) {
    if (!isResizing(rail)) {
      return ;
    }
    try {
      handle.releasePointerCapture($$event.pointerId);
    }
    catch (exn){
      
    }
    finishResizeInteraction(rail);
    var match = rail._gdcDidDrag;
    if (match !== undefined && match) {
      return commitRailWidth(readRailWidthVar());
    }
    var expanded = DomEl$GameDataCore.data(rail, "expanded") !== "true";
    commitRailWidth(expanded ? 220 : 52);
  };
  var onPointerCancel = function ($$event) {
    if (!isResizing(rail)) {
      return ;
    }
    try {
      handle.releasePointerCapture($$event.pointerId);
    }
    catch (exn){
      
    }
    finishResizeInteraction(rail);
    commitRailWidth(getSavedWidth());
  };
  handle.addEventListener("pointerdown", onPointerDown);
  handle.addEventListener("pointermove", onPointerMove);
  handle.addEventListener("pointerup", onPointerUp);
  handle.addEventListener("pointercancel", onPointerCancel);
  rail._gdcPointerDown = onPointerDown;
  rail._gdcPointerMove = onPointerMove;
  rail._gdcPointerUp = onPointerUp;
  rail._gdcPointerCancel = onPointerCancel;
  rail._gdcBoundHandle = Caml_option.some(handle);
}

function restoreRailFromStorage(rail) {
  var saved = getSavedWidth();
  if (readRailWidthVar() !== saved) {
    applyNavRailWidthPx(saved);
  } else {
    setRailDataset(Caml_option.some(rail), saved);
  }
  SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
}

function syncRailInteraction(rail) {
  var viewportWidth = window.innerWidth;
  if (viewportWidth <= appShellNarrowMaxPx) {
    if (isResizing(rail)) {
      finishResizeInteraction(rail);
    }
    return unbindResizeHandle(rail);
  } else {
    if (!isResizing(rail)) {
      restoreRailFromStorage(rail);
    }
    return bindResizeHandle(rail);
  }
}

function mounted() {
  var self = this ;
  var rail = self.el;
  syncRailInteraction(rail);
  var onResize = function (param) {
    syncRailInteraction(rail);
  };
  window.addEventListener("resize", onResize, {});
  rail._gdcResizeCleanup = (function () {
      window.removeEventListener("resize", onResize);
    });
}

function updated() {
  var self = this ;
  syncRailInteraction(self.el);
}

function destroyed() {
  var self = this ;
  var rail = self.el;
  var cleanup = rail._gdcResizeCleanup;
  if (cleanup !== undefined) {
    cleanup();
  }
  rail._gdcResizeCleanup = undefined;
  unbindResizeHandle(rail);
  finishResizeInteraction(rail);
}

document.addEventListener("DOMContentLoaded", (function (param) {
        applyPersistedMainNavRail();
      }));

var mainNavRail = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var MainNavRail = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var syncAppSidebarPad = SidebarPadSyncHook$GameDataCore.syncAppSidebarPad;

var appShellMdMinPx = 1480;

var collapsedWidth = 52;

var expandedWidth = 220;

var dragClickThresholdPx = 4;

export {
  syncAppSidebarPad ,
  appShellMdMinPx ,
  appShellNarrowMaxPx ,
  collapsedWidth ,
  expandedWidth ,
  snapThreshold ,
  dragClickThresholdPx ,
  expandedStorageKey ,
  widthStorageKey ,
  railWidthVar ,
  emptyPayload ,
  isDrawerViewport ,
  snapNavRailWidth ,
  clampNavRailPreviewWidth ,
  getSavedExpanded ,
  setSavedExpanded ,
  getSavedWidth ,
  readRailWidthVar ,
  getMainNavRailWidth ,
  setRailDataset ,
  applyNavRailWidthPx ,
  previewRailWidth ,
  commitRailWidth ,
  applyPersistedMainNavRail ,
  isResizing ,
  finishResizeInteraction ,
  removeHandleListener ,
  unbindResizeHandle ,
  bindResizeHandle ,
  restoreRailFromStorage ,
  syncRailInteraction ,
  mounted ,
  updated ,
  destroyed ,
  mainNavRail ,
  MainNavRail ,
}
/* mounted Not a pure module */
